import { Link, useLocation } from "react-router-dom";
import { propertiesRoutes } from "../../app/routes";
import { RouteItem } from "../../models/routes/routeItem";
import { filterItemRoutesByConfig, filterItemRoutesByPaths } from "../../services/routes/filter";
import "./RightMenu.scss";

const RightMenu: React.FC<{ routes: RouteItem[] }> = (props) => {
  const { pathname } = useLocation();

  const excludedRoutes = [
    "",
    propertiesRoutes.caseworkerFrontPage.path,
    propertiesRoutes.citizenFrontPage.path,
    propertiesRoutes.property.path,
    propertiesRoutes.payment.path,
  ] as string[];
  const filteredRoutesByPaths = filterItemRoutesByPaths(props.routes, excludedRoutes);
  const filteredRoutes = filterItemRoutesByConfig(filteredRoutesByPaths);

  return (
    <div className="bg-white p-3 p-lg-4">
      <nav>
        <ul className="link-list" data-ident="subtree" aria-label="Relevante links">
          {filteredRoutes.map((route) => {
            const isActive = pathname === route.path;
            return (
              <li
                className={isActive ? "active" : undefined}
                aria-current={isActive ? "page" : undefined}
                key={route.path}
              >
                <Link data-click="søstermenu" data-stat="sister_click" data-value={route.title} to={route.path}>
                  {route.title}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default RightMenu;
